module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "disclaimer"
    }
  }, [_vm._v("Veuillez consulter ce site sur smartphone.")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40143881"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Disclaimer.vue
// module id = 259
// module chunks = 0